module.exports = __webpack_public_path__ + "static/media/kuo.49681e41.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Pictures/pics/kuo.jpeg
// module id = 137
// module chunks = 0